import React from "react";
import "./progress-bar.scss";

interface ProgressBarProps {
    progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
    return (
        <div className="progress-bar-ui">
            <div className="progress-bar-container">
                <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
            </div>
            <div className="progress-bar-text">{Math.round(progress)}%</div>
        </div>
    );
}

export default ProgressBar;